import { KNM_FILE_SIZE_ERROR_BIG } from 'CorePackage/MainModule/constants/notices';

import { addNoticeAction } from '../actions/NoticeActions';
import { MessageTypesEnum } from '../enums/MessageTypesEnum';
import { NoticeTypesEnum } from '../enums/NoticeTypesEnum';

export const addNoticeKnmFileSizeErrorBig = () =>
  addNoticeAction({
    renderContent: KNM_FILE_SIZE_ERROR_BIG,
    noticeType: NoticeTypesEnum.ERROR,
    messageType: MessageTypesEnum.FILE_SIZE,
  });
